<template>
<div>
  <v-card height="100%" flat class="mt-3">
    <v-tabs
      background-color="transparent"      
      grow
      show-arrows
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab>
          Map
      </v-tab>
      <v-tab>
        Calendar
      </v-tab>
      <v-tab>
        List
      </v-tab>
      <v-tab-item>
        <v-card flat height="500px" class="purple">          
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat height="100%">
          <v-calendar
          :weekdays="weekdays"
          :event-overlap-mode="mode"
          first-interval="7"
          interval-count="12"
          :events="events"
          value="today"
          now="today"
          color="primary"
          type="week"
        ></v-calendar>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat height="100%">
          <!-- <v-img src="https://picsum.photos/510/300?random" aspect-ratio="1.7"></v-img> -->
        </v-card>
      </v-tab-item>
    </v-tabs>    
  </v-card>
  
  </div>
</template>
<script>
  
  export default {
    name: 'Planner',
    
    components: {
      
    },
    data () {
      return {
        weekdays : [6 ,0, 1, 2, 3, 4],
        mode: 'column',
        events: [
          {
            name: 'Weekly Meeting',
            start: '2020-08-09 09:00',
            end: '2020-08-09 10:00',
          },
          {
            name: 'Thomas\' Birthday',
            start: '2020-08-10',
          },
          {
            name: 'Mash Potatoes',
            start: '2020-08-13 12:30',
            end: '2020-08-13 15:30',
          },
        ],
      }
    },
  }
</script>

<style>

</style>
